import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "mx-auto px-4 lg:px-8 max-w-7xl" };
const _hoisted_2 = { class: "text-center mb-8" };
const _hoisted_3 = { class: "text-4xl lg:text-5xl font-bold text-black mb-4 dark:text-white" };
const _hoisted_4 = { class: "text-lg text-neutral-600 mx-auto dark:text-neutral-400 max-w-2xl" };
const _hoisted_5 = {
    key: 0,
    class: "bg-white dark:bg-neutral-950 rounded-2xl shadow-lg p-8 text-center border border-neutral-200 dark:border-neutral-800"
};
const _hoisted_6 = { key: 1 };
const _hoisted_7 = {
    key: 0,
    class: "bg-white dark:bg-neutral-950 rounded-2xl shadow-lg p-12 text-center border border-neutral-200 dark:border-neutral-800"
};
const _hoisted_8 = {
    key: 1,
    class: "bg-white dark:bg-neutral-950 rounded-2xl shadow-lg p-8 text-center border border-neutral-200 dark:border-neutral-800"
};
const _hoisted_9 = { class: "text-red-600 dark:text-red-400 mb-4" };
const _hoisted_10 = {
    key: 2,
    class: "grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
};
const _hoisted_11 = ["href", "target"];
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = { class: "p-4 space-y-2" };
const _hoisted_14 = {
    key: 0,
    class: "text-neutral-700 dark:text-neutral-300 line-clamp-3"
};
const _hoisted_15 = { class: "text-xs text-neutral-500 dark:text-neutral-400 flex items-center justify-between gap-2" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { key: 1 };
const _hoisted_18 = { key: 2 };
const _hoisted_19 = {
    key: 3,
    class: "bg-white dark:bg-neutral-950 rounded-2xl shadow-lg p-8 text-center border border-neutral-200 dark:border-neutral-800"
};
const _hoisted_20 = { class: "text-neutral-700 dark:text-neutral-300" };
import { computed, ref, watch } from 'vue';
import { useInstagramFeed } from '../composables/useInstagramFeed';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InstagramFeed',
    props: {
        apiClient: {},
        consentGranted: { type: Boolean },
        heading: { default: 'Instagram Feed' },
        subtitle: { default: 'Aktuelle Eindrücke aus unserem Restaurant' },
        maxItems: { default: 6 },
        cacheKey: {},
        emptyStateText: { default: 'Aktuell sind keine Instagram Beiträge verfügbar.' }
    },
    setup(__props) {
        const props = __props;
        const consent = ref(props.consentGranted);
        const rootEl = ref(null);
        watch(() => props.consentGranted, (newValue) => {
            consent.value = newValue;
        });
        const cacheKey = computed(() => props.cacheKey ?? `instagram-feed-${props.apiClient.getProjectIdentifier()}`);
        const { items, meta, isLoading, error, hasFetched, refetch } = useInstagramFeed({
            apiClient: props.apiClient,
            target: rootEl,
            consentGranted: consent,
            cacheKey: cacheKey.value
        });
        const displayItems = computed(() => items.value.slice(0, props.maxItems));
        const shouldShowSection = computed(() => true);
        const showCaptions = computed(() => meta.value?.settings?.showCaptions !== false);
        const showLikes = computed(() => meta.value?.settings?.showLikes === true);
        const showComments = computed(() => meta.value?.settings?.showCommentsCount === true);
        const showPostDate = computed(() => meta.value?.settings?.showPostDate !== false);
        const openInNewTab = computed(() => meta.value?.settings?.openLinksInNewTab !== false);
        const formatDate = (dateString) => {
            const date = new Date(dateString);
            if (Number.isNaN(date.getTime()))
                return '';
            return date.toLocaleDateString('de-DE', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        };
        const openCookieSettings = () => {
            if (typeof window === 'undefined')
                return;
            window.dispatchEvent(new CustomEvent('open-cookie-settings'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                ref_key: "rootEl",
                ref: rootEl,
                class: _normalizeClass(["bg-neutral-50 dark:bg-neutral-900 transition-opacity duration-300", [shouldShowSection.value ? 'py-12 lg:py-16 opacity-100' : 'py-0 opacity-0 pointer-events-none h-0 overflow-hidden']])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "title", {}, () => [
                                _createTextVNode(_toDisplayString(_ctx.heading), 1 /* TEXT */)
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                                _createTextVNode(_toDisplayString(_ctx.subtitle), 1 /* TEXT */)
                            ])
                        ])
                    ]),
                    (!consent.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, "consent", {}, () => [
                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-neutral-700 dark:text-neutral-300" }, " Bitte stimmen Sie „Externe Inhalte“ zu, um Instagram-Inhalte zu sehen. ", -1 /* CACHED */)),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "mt-4 inline-flex items-center rounded-full bg-black px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 dark:bg-white dark:text-black dark:hover:bg-neutral-200",
                                    onClick: openCookieSettings
                                }, " Zu den Cookie-Einstellungen ")
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_unref(isLoading))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _renderSlot(_ctx.$slots, "loading", {}, () => [
                                        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-neutral-700 dark:text-neutral-300" }, "Instagram Feed wird geladen …", -1 /* CACHED */))
                                    ])
                                ]))
                                : (_unref(error))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _renderSlot(_ctx.$slots, "error", { error: _unref(error) }, () => [
                                            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(error)), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[0] || (_cache[0] =
                                                    //@ts-ignore
                                                    (...args) => (_unref(refetch) && _unref(refetch)(...args))),
                                                class: "bg-black dark:bg-white text-white dark:text-black px-4 py-2 rounded-full font-semibold hover:bg-neutral-800 dark:hover:bg-neutral-100 transition-colors"
                                            }, " Erneut versuchen ")
                                        ])
                                    ]))
                                    : (displayItems.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayItems.value, (item, index) => {
                                                return (_openBlock(), _createElementBlock("a", {
                                                    key: item.instagramMediaId,
                                                    href: item.permalink,
                                                    target: openInNewTab.value ? '_blank' : '_self',
                                                    rel: "noopener",
                                                    class: "bg-white dark:bg-neutral-950 rounded-2xl shadow-lg border border-neutral-200 dark:border-neutral-800 overflow-hidden opacity-0 animate-fade-in",
                                                    style: _normalizeStyle({ animationDelay: `${index * 60}ms` })
                                                }, [
                                                    _createElementVNode("img", {
                                                        src: item.thumbnailUrl || item.mediaUrl,
                                                        alt: item.caption || 'Instagram Post',
                                                        loading: "lazy",
                                                        class: "w-full aspect-square object-cover bg-neutral-100 dark:bg-neutral-800"
                                                    }, null, 8 /* PROPS */, _hoisted_12),
                                                    _createElementVNode("div", _hoisted_13, [
                                                        (showCaptions.value)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(item.caption || 'Instagram Post'), 1 /* TEXT */))
                                                            : _createCommentVNode("v-if", true),
                                                        _createElementVNode("div", _hoisted_15, [
                                                            (showPostDate.value)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(formatDate(item.timestamp)), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true),
                                                            (showLikes.value)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "❤ " + _toDisplayString(item.likeCount ?? 0), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true),
                                                            (showComments.value)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "💬 " + _toDisplayString(item.commentsCount ?? 0), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ])
                                                ], 12 /* STYLE, PROPS */, _hoisted_11));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _renderSlot(_ctx.$slots, "empty", {}, () => [
                                                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.emptyStateText), 1 /* TEXT */)
                                            ])
                                        ]))
                        ]))
                ])
            ], 2 /* CLASS */));
        };
    }
});
